import { Button } from '@domcrm/ui';
import { Moon, Sun } from 'lucide-react';
import { useStaffTheme } from './staff-theme-context';

export type StaffThemeToggleProps = {
  className?: string;
};

/** Переключатель светлой / тёмной темы (`data-theme` на `<html>`). */
export function StaffThemeToggle({ className }: StaffThemeToggleProps) {
  const { theme, toggleTheme } = useStaffTheme();
  const isDark = theme === 'dark';

  return (
    <Button
      type="button"
      variant="ghost"
      className={className}
      aria-label={isDark ? 'Включить светлую тему' : 'Включить тёмную тему'}
      onClick={toggleTheme}
    >
      {isDark ? <Sun className="size-[18px]" strokeWidth={2} aria-hidden /> : <Moon className="size-[18px]" strokeWidth={2} aria-hidden />}
    </Button>
  );
}
